
<div style="position:relative;">
      <h4 style="text-align: right;margin-top:0px;position:absolute;top:-10px;right:-5px" (click)="onclick('cancel')" class="pointer">X</h4>
      <h3 class="heading-center">{{languageData['Popups']['VarWeb-PcPopups3']|| "Weiter zur Finanzierung"}}</h3>
</div>


<p class="prewrap">{{languageData['Popups']['VarWeb-PcPopups4']}}</p>
<button class="au-btn btn-default pointer"  (click)="onclick('continue')"
      style="margin-top:5px">{{languageData['Popups']['VarWeb-PcPopups5']|| "Weiter zur Bonitätsprüfung"}}</button>